import { ReactNode } from 'react';

import { Box, Stack } from '@mui/material';

type Props = {
  creditsSlot?: ReactNode;
  sidebarSlot?: ReactNode;
};

export const RecordingHeader = ({ creditsSlot, sidebarSlot }: Props) => (
  <Stack
    sx={{
      bgcolor: 'common.white',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '12px',
      minHeight: '72px',
      padding: '12px 16px 16px',
      position: 'sticky',
      top: 0,
      zIndex: (theme) => theme.zIndex.sidebar,
    }}
    alignItems="center"
    component="header"
  >
    {sidebarSlot}
    <Box sx={{ alignItems: 'center', display: 'flex', gap: { tablet: '12px', xs: '8px' }, ml: 'auto' }}>
      {creditsSlot}
    </Box>
  </Stack>
);
